import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ProgressSpinnerDialogComponent } from '@shared/components/progress-spinner-dialog/progress-spinner-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ProgressSpinnerDialogService {
  private instances: {
    [key: string]: MatDialogRef<ProgressSpinnerDialogComponent>;
  } = {};

  constructor(private dialog: MatDialog) {}

  /**
   * Open a progress spinner dialog
   *
   * @returns dialog identifier, to use with `close(dialogRefId)`
   */
  public show = (): string => {
    const dialogRef = this.dialog.open(ProgressSpinnerDialogComponent, {
      panelClass: ['transparent', ''],
      disableClose: true
    });

    this.instances[dialogRef.id] = dialogRef;
    return dialogRef.id;
  };

  /**
   * Close all progress spinner dialogs
   *
   */
  public hideAll = (): void => {
    if (Object.keys(this.instances).length > 0) {
      Object.keys(this.instances).forEach((k) => this.hide(k));
    }
    const containers = document.getElementsByClassName('cdk-overlay-container');
    if (containers?.length) {
      Array.from(containers).forEach((container) => {
        const matDialogElements = container.querySelectorAll('.mat-dialog-container');
        Array.from(matDialogElements)
          .filter((element) => element.querySelector('app-progress-spinner-dialog') !== null)
          .map((element) => element.id)
          .filter((id) => id)
          .forEach((id) => {
            this.dialog.getDialogById(id)?.close();
          });
      });
    }
  };

  /**
   * Close given progress spinner dialog
   *
   * @param dialogRefId dialog identifier, obtained when calling `show()`
   */
  public hide = (dialogRefId: string) => {
    const ref = this.instances[dialogRefId];
    if (ref) {
      ref.close();
      delete this.instances[dialogRefId];
    }
  };
}
